'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _paths = require('ifeis-isomorphic/lib/redux/actions/accounts/paths');

var _paths2 = require('ifeis-isomorphic/lib/redux/actions/person/paths');

var _paths3 = require('ifeis-isomorphic/lib/redux/actions/events/paths');

var _immutable = require('immutable');

exports.default = function (feis_id, person_id) {
  return function (state) {

    var loading = false;
    if ((0, _paths.personIsLoading)(state, person_id) || (0, _paths3.resultsForPersonIsLoading)(state, feis_id, person_id) || !(0, _paths3.getResultsByPerson)(state, feis_id, person_id)) {
      return {
        loading: true,
        scores: (0, _immutable.List)(),
        person: (0, _immutable.Map)()
      };
    }

    var eventIdsForPersonResults = (0, _paths3.getResultsByPerson)(state, feis_id, person_id);

    var events = eventIdsForPersonResults.map(function (eid) {

      var event = (0, _paths3.getEvent)(state, eid);
      var rank = (0, _paths3.getPlacementForPersonInEvent)(state, eid, person_id).get('placement');
      var placed = (0, _paths3.getPlacedForPersonInEvent)(state, eid, person_id);

      return { event: event, placed: placed, rank: rank };
    });

    var person = (0, _paths2.getPerson)(state, person_id);

    return { loading: loading, events: events, person: person };
  };
};


//////////////////
// WEBPACK FOOTER
// ./routes/feiseanna/one/results/for-person/mapStateToController.js
// module id = 595
// module chunks = 0